import { render, staticRenderFns } from "./ChangePasswordDetail.vue?vue&type=template&id=5e3c35dc&"
import script from "./ChangePasswordDetail.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports